<template>
  <div class="recent-articles">
    <PageTitle main="Artigos mais recentes" />
    <ul>
      <li v-for="article in recentArticles" :key="article.id">
        <ArticleItem
          :isPublicationDate="true"
          :isViews="false"
          :article="article"
        />
      </li>
    </ul>
    <PageTitle main="Artigos mais populares" v-if="!user"/>
    <ul v-if="!user">
      <li v-for="article in popularArticles" :key="article.id">
        <ArticleItem
          :isPublicationDate="false"
          :isViews="true"
          :article="article"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle.vue";
import ArticleItem from "../article/ArticleItem.vue";
import { mapState } from "vuex";
export default {
  name: "RecentArticle",
  props: ["recentArticles", "popularArticles"],
  components: {
    ArticleItem,
    PageTitle,
  },
  computed: mapState(["user"]),
};
</script>

<style>

.recent-articles-title {
  font-size: 1.3rem;
  color: #545454;
}

.recent-articles ul {
  list-style-type: none;
  padding: 0px;
}
</style>